import cn from 'classnames';
import React from 'react';

import DynamicHeightTextarea from '../../Textarea/DynamicHeightTextarea';

export const DynamicTextarea = ({className, text: placeholder, ...rest}) => {
    return (
        <DynamicHeightTextarea
            className={cn(
                'w-full resize-none border-border text-start placeholder-primary',
                'placeholder:truncate placeholder-shown:text-ellipsis focus:placeholder-border',
                'border py-3 ml:rounded-sm ml:border-primary ml:bg-romance',
                className
            )}
            placeholder={placeholder}
            aria-label={placeholder}
            {...rest}
        />
    );
};
